import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { deleteParticipantPitch } from '../actions';

const DropArea = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    text-align: center;
    text-transform: uppercase;
    border: 2px dashed #a5a5a55e;
    background-color: #fff;
    transition: all 0.2s ease;
    ${({ isHover }) => isHover && 'background: #d3d3d32e; border-color: #a5a5a5b0;'};
`;

class DeleteArea extends Component {
    state = {
        isHover: false
    };

    drop = event => {
        const position = event.dataTransfer.getData('position');

        if (position) {
            this.props.deleteParticipantPitch(position);
            event.dataTransfer.clearData();
        }

        this.setState({
            isHover: false
        });
    };

    dragOver = event => {
        event.preventDefault();

        if (!this.state.isHover) {
            this.setState({ isHover: true });
        }
    };

    dragLeave = event => {
        event.preventDefault();

        if (this.state.isHover) {
            this.setState({
                isHover: false
            });
        }
    };

    render() {
        return (
            <DropArea
                onDrop={this.drop}
                onDragOver={this.dragOver}
                onDragLeave={this.dragLeave}
                isHover={this.state.isHover}
            >
                drop here<br />to delete
            </DropArea>
        );
    }
}

DeleteArea.propTypes = {
    // From connect
    deleteParticipantPitch: PropTypes.func.isRequired
};

export default connect(
    null,
    { deleteParticipantPitch }
)(DeleteArea);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/DeleteArea.js
 **/